"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* -------------------------------------------------------------------------

	PUNITED.utils

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */

// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.utils) PUNITED.utils = {};
(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.utils;
  var props = {
    noScroll: {
      offset: {
        right: '--no-scroll--offset--right'
      }
    }
  };

  /* -----------------------------------------------------
  	----------------------------------------------------- */
  ns.preventScroll = function () {
    var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    var offset = "".concat(scrollbarWidth, "px");
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = offset;
    document.documentElement.style.setProperty(props.noScroll.offset.right, offset);
  };

  /* -----------------------------------------------------
  	----------------------------------------------------- */
  ns.allowScroll = function () {
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
    document.documentElement.style.removeProperty(props.noScroll.offset.right);
  };
  ns.modal = function (modal) {
    var triggers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // const triggers = triggerSelector ? document.querySelectorAll(triggerSelector) : [];
    // const modal = document.querySelector(selector);
    var backdrop = modal.querySelector('.modal__backdrop');
    var inner = modal.querySelector('.modal-content');
    var outerNodes = modal.querySelectorAll('.modal__inner, .modal__backdrop, .modal-close-btn');
    var outerNodesArray = Array.from(outerNodes);
    var isTransitioning = false;
    var computedOptions = _objectSpread({
      open: false,
      closeByBackdrop: true,
      onOpenStart: null,
      onOpenEnd: null,
      onCloseStart: null,
      onCloseEnd: null
    }, options);
    if (computedOptions.open) {
      openModal();
    }
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (isTransitioning) {
          return;
        }
        openModal();
      });
    });
    modal.addEventListener('click', function (e) {
      if (isTransitioning) {
        return;
      }
      if (computedOptions.closeByBackdrop && outerNodesArray.includes(e.target)) {
        closeModal();
      }
    });
    function openModal() {
      isTransitioning = true;
      gsap.timeline({
        onStart: function onStart() {
          if (computedOptions.onOpenStart) {
            computedOptions.onOpenStart();
          }
          gsap.set(modal, {
            zIndex: 9999,
            opacity: 1
          });
          PUNITED.utils.preventScroll();
        },
        onComplete: function onComplete() {
          isTransitioning = false;
          if (computedOptions.onOpenEnd) {
            computedOptions.onOpenEnd();
          }
        }
      }).to(backdrop, {
        opacity: 1,
        duration: 0.1,
        ease: 'power4.out'
      }).to(inner, {
        opacity: 1,
        scale: 1,
        duration: 0.5,
        ease: 'power4.out'
      }, '<');
    }
    function closeModal() {
      isTransitioning = true;
      gsap.timeline({
        onStart: function onStart() {
          if (computedOptions.onCloseStart) {
            computedOptions.onCloseStart();
          }
        },
        onComplete: function onComplete() {
          gsap.set(modal, {
            zIndex: -1,
            opacity: 0
          });
          if (computedOptions.onCloseEnd) {
            computedOptions.onCloseEnd();
          }
          isTransitioning = false;
          PUNITED.utils.allowScroll();
        }
      }).to(inner, {
        opacity: 0,
        scale: 0.9,
        duration: 0.25,
        ease: 'power2.out'
      }).to(backdrop, {
        opacity: 0,
        duration: 0.05,
        ease: 'power2.out'
      }, '<');
    }
    return {
      open: openModal,
      close: closeModal
    };
  };
  ns.horizontalScroller = function (selector) {
    var tables = document.querySelectorAll(selector);
    if (tables.length < 1) {
      return;
    }
    var pointerMedia = window.matchMedia("(pointer: coarse)");
    var widthMedia = window.matchMedia("(max-width: 679px)");
    var containers = [];
    tables.forEach(function (table) {
      containers.push(wrapTable(table));
    });
    containers.forEach(function (container) {
      var trigger = init(widthMedia.matches, container, null);
      // widthMedia.addEventListener('change', (e) => {
      // 	trigger = init(e.matches, container, trigger);
      // });

      var observer = new ResizeObserver(function () {
        trigger = init(widthMedia.matches, container, trigger);
      });
      observer.observe(container);
    });

    // let scrollTriggers = [];

    function init(widthMatches, container, trigger) {
      handleWidthChange(widthMatches, container);
      destroy(container, trigger);
      return create(container);
    }
    function create(container) {
      // containers.forEach((container) => {
      var scroller = container.querySelector('.horizontal_scroll__scroller');
      handleScrollEdge({
        currentTarget: scroller
      });
      scroller.addEventListener("scroll", handleScrollEdge, {
        passive: true
      });
      if (container.classList.contains("--scrolled") || scroller.scrollWidth <= scroller.clientWidth) {
        return;
      }
      container.classList.add("--hinted");
      scroller.addEventListener("scroll", handleScroll, {
        passive: true,
        once: true
      });
      var trigger = ScrollTrigger.create({
        trigger: container,
        start: "top 50%",
        end: "top 50%",
        toggleClass: "--played",
        once: true
      });
      return trigger;
      // scrollTriggers.push(trigger);
      // });
    }
    function destroy(container, trigger) {
      // containers.forEach((container) => {
      container.classList.remove("--hinted");
      var scroller = container.querySelector('.horizontal_scroll__scroller');
      scroller.removeEventListener("scroll", handleScroll);
      scroller.removeEventListener("scroll", handleScrollEdge);
      // });
      // scrollTriggers.forEach((trigger) => {
      trigger === null || trigger === void 0 || trigger.kill();
      // });
    }
    function handleScroll(e) {
      e.currentTarget.parentNode.classList.add("--scrolled");
    }
    function handleScrollEdge(e) {
      e.currentTarget.parentNode.classList.toggle('--edge', e.currentTarget.scrollLeft + e.currentTarget.clientWidth === e.currentTarget.scrollWidth);
    }
    function handleWidthChange(widthMatches, container) {
      var matches = pointerMedia.matches || widthMatches;
      // containers.forEach((container) => {
      container.classList.toggle('--touch', matches);
      // });
    }
    function wrapTable(table) {
      var scroll = document.createElement('div');
      scroll.classList.add('horizontal_scroll');
      table.parentNode.insertBefore(scroll, table);
      var mouseText = document.createElement('div');
      mouseText.classList.add('--mouse');
      mouseText.innerHTML = '表をクリックして<br >キーボードの矢印でスクロール';
      var touchText = document.createElement('div');
      touchText.classList.add('--touch');
      // touchText.textContent = '横にスワイプできます';

      var hintText = document.createElement('div');
      hintText.classList.add('horizontal_scroll__hint_text');
      hintText.append(mouseText, touchText);
      var hintIcon = document.createElement('div');
      hintIcon.classList.add('horizontal_scroll__hint_icon');
      var hintBox = document.createElement('div');
      hintBox.classList.add('horizontal_scroll__hint_box');
      hintBox.append(hintIcon, hintText);
      var hint = document.createElement('div');
      hint.classList.add('horizontal_scroll__hint');
      hint.append(hintBox);
      var content = document.createElement('div');
      content.classList.add('horizontal_scroll__content');
      content.appendChild(table);
      var scroller = document.createElement('div');
      scroller.classList.add('horizontal_scroll__scroller');
      scroller.append(content);
      scroll.append(hint, scroller);
      return scroll;
    }
  };
  ns.pageHeaderSlider = function () {
    var slider = document.querySelector('.page_header__slider .splide');
    if (!slider) {
      return;
    }
    var track = slider.querySelector('.splide__track');
    var list = slider.querySelector('.splide__list');
    var slides = slider.querySelectorAll('.splide__slide');
    if (slides.length < 2) {
      list.classList.add('--pc_align_center');
    }
    var bgSlider = document.querySelector('.page_header__bg_slider .splide');
    bgSlider.append(track.cloneNode(true));
    var bgSplide = new Splide(bgSlider, {
      type: 'fade',
      speed: 1000,
      easing: 'ease',
      drag: false,
      arrows: false,
      pagination: false
    });
    var slideSpeed = 400;
    var slideDelay = 3000;
    var splide = new Splide(slider, {
      type: slides.length > 2 ? 'loop' : 'slide',
      rewind: true,
      speed: slideSpeed,
      easing: 'ease',
      autoplay: true,
      interval: slideSpeed + slideDelay,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: slides.length > 1,
      arrows: slides.length > 1,
      pagination: slides.length > 1,
      gap: 24,
      heightRatio: 360 / 960,
      breakpoints: {
        680: {
          arrows: false,
          gap: 12,
          heightRatio: 160 / 284
        }
      }
    });
    bgSplide.sync(splide);
    bgSplide.mount();
    splide.mount();
  };
  ns.productGallery = function () {
    var _thumbnail;
    var container = document.querySelector('.product_detail_gallery');
    if (!container) {
      return;
    }
    var slides = container.querySelectorAll('.product_detail_gallery__slide');
    var imgMode = slides.length === 1;
    if (imgMode) {
      container.classList.add('--mode_img');
    }
    var mainNode = document.querySelector('.product_detail_gallery__main');
    var main = new Splide(mainNode, {
      type: imgMode ? 'slide' : 'loop',
      // autoplay: true,
      pagination: false,
      gap: 24,
      drag: !imgMode,
      arrows: !imgMode,
      breakpoints: {
        680: {
          gap: 12
        }
      }
    });
    var thumbnail;
    if (!imgMode) {
      var thumbnailNode = document.querySelector('.product_detail_gallery__thumbnail');
      var track = mainNode.querySelector('.splide__track');
      var trackCloned = track.cloneNode(true);
      trackCloned.querySelectorAll('.product_detail_gallery__title').forEach(function (title) {
        return title.remove();
      });
      thumbnailNode.append(trackCloned);
      thumbnail = new Splide(thumbnailNode, {
        fixedWidth: 56,
        fixedHeight: 56,
        gap: 8,
        rewind: true,
        arrows: false,
        pagination: false,
        isNavigation: true
      });
    }
    if (!imgMode) {
      main.sync(thumbnail);
    }
    main.mount();
    (_thumbnail = thumbnail) === null || _thumbnail === void 0 || _thumbnail.mount();
  };
  ns.imageSlider = function () {
    var containers = document.querySelectorAll('.image_slider');
    if (containers.length < 1) {
      return;
    }
    containers.forEach(function (container) {
      var isFullWidth = container.classList.contains('--full_width');
      var isProduct = container.classList.contains('--product');
      var perPage = isFullWidth ? 3 : isProduct ? 6 : 1;
      var perPageSp = isProduct ? 2 : 1;
      var gap = isProduct ? 10 : 40;
      var gapSp = isProduct ? 10 : 24;
      var list = container.querySelector('.splide__list');
      var slides = container.querySelectorAll('.splide__slide');
      var showNav = slides.length > perPage || slides.length === perPage && isFullWidth;
      if (!showNav) {
        container.classList.add('--pc_no_nav');
      }
      if (slides.length < perPage) {
        list.classList.add('--pc_align_center');
      }
      var slideSpeed = isProduct ? 1000 : 400;
      var slideDelay = isProduct ? 6000 : 3000;
      var splide = new Splide(container.querySelector('.splide'), {
        type: showNav ? 'loop' : 'slide',
        focus: isProduct ? undefined : 0,
        perPage: perPage,
        perMove: isProduct ? perPage : 1,
        rewind: true,
        speed: slideSpeed,
        easing: 'ease',
        autoplay: true,
        interval: slideSpeed + slideDelay,
        pauseOnHover: false,
        pauseOnFocus: false,
        drag: showNav,
        arrows: showNav,
        pagination: showNav,
        gap: gap,
        // heightRatio: 560 / 373,
        breakpoints: {
          680: {
            type: slides.length > 1 ? 'loop' : 'slide',
            perPage: perPageSp,
            perMove: isProduct ? 2 : 1,
            drag: slides.length > 1,
            arrows: slides.length > 1,
            pagination: slides.length > 1,
            gap: gapSp
            // heightRatio: 160 / 284,
          }
        }
      });
      splide.mount();
    });
  };
  ns.charSelect = function () {
    var container = document.querySelector('.char_select');
    if (!container) {
      return;
    }
    var childWrappers = container.querySelectorAll('.char_select__child');
    var childGroups = container.querySelectorAll('.char_select__btns');
    var parentInputs = container.querySelectorAll('.char_select__input_parent');
    var childInputs = container.querySelectorAll('.char_select__input_child');
    var lastParentChecked = null;
    var lastChildChecked = null;
    parentInputs.forEach(function (input) {
      input.addEventListener('change', handleParentChange);
      input.addEventListener('click', handleParentClick);
      if (input.checked) {
        lastParentChecked = input;
        handleChange(input);
      }
    });
    childInputs.forEach(function (input) {
      input.addEventListener('click', handleChildClick);
      if (input.checked) {
        lastChildChecked = input;
      }
    });
    function handleParentClick(e) {
      lastParentChecked = handleClick(e.currentTarget, lastParentChecked, true);
    }
    function handleChildClick(e) {
      lastChildChecked = handleClick(e.currentTarget, lastChildChecked, true);
    }
    function handleClick(target, lastTarget) {
      var triggerEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (target.isSameNode(lastTarget)) {
        lastTarget = null;
        target.checked = false;
        if (triggerEvent) {
          target.dispatchEvent(new Event('change'));
        }
      } else if (target.checked) {
        lastTarget = target;
      }
      return lastTarget;
    }
    function handleParentChange(e) {
      var input = e.currentTarget;
      handleChange(input, true);
    }
    function handleChange(input) {
      var resetChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var checked = input.checked;
      var value = input.value;
      var child = container.querySelector("#char_select_".concat(value));
      var list = child.closest('.char_select__btns');
      var wrapper = list.closest('.char_select__child');
      childGroups.forEach(function (group) {
        group.classList.toggle('--active', !checked ? false : group.isSameNode(list));
      });
      childWrappers.forEach(function (w) {
        w.classList.toggle('--active', !checked ? false : w.isSameNode(wrapper));
      });
      if (resetChild) {
        childInputs.forEach(function (input) {
          input.checked = false;
        });
      }
    }
  };
  ns.anchorMenu = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.page_menu__link';
    var mq = PUNITED.common.mediaQuery;
    var images = Array.from(document.querySelectorAll('.wp-block-image:not(.sp_none) img[loading="lazy"]'));
    var completeImages = images.map(function (image) {
      return image.complete;
    });
    if (mq.matches) {
      images.forEach(function (image) {
        return image.loading = 'eager';
      });
    }
    var currentTarget;
    var links = document.querySelectorAll(selector);
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href.startsWith('#')) {
        return;
      }
      var id = href.replace('#', '');
      var target = document.getElementById(id);
      if (!target) {
        return;
      }
      init(link, href, target);
    });
    function init(link, href, target) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        currentTarget = target;
        if (!mq.matches || isEveryImageLoaded()) {
          scrollToCurrent();
          return;
        }
        preloadImages();
      });
    }
    function scrollToCurrent() {
      var _currentTarget;
      (_currentTarget = currentTarget) === null || _currentTarget === void 0 || _currentTarget.scrollIntoView({
        behavior: 'smooth'
      });
      currentTarget = null;
    }
    function preloadImages() {
      images.forEach(function (image, i) {
        if (image.complete) {
          completeImages[i] = image.complete;
          return;
        }
        image.addEventListener('load', function () {
          completeImages[i] = image.complete;
          if (isEveryImageLoaded()) {
            scrollToCurrent();
          }
        });
      });
      if (isEveryImageLoaded()) {
        scrollToCurrent();
      }
    }
    function isEveryImageLoaded() {
      return completeImages.every(function (complete) {
        return complete;
      });
    }
  };
  ns.handleTestReportForm = function () {
    var form = document.querySelector('.report_search_form');
    var error = form.querySelector('.report_search_form__validation');
    var result = document.querySelector('.report_search_results');
    var inner = result.querySelector('.report_search_results__inner');
    var url = form.getAttribute('action');
    var method = 'POST';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      handleReset();
      var formData = new FormData(form);
      if (!formData.get('s').trim()) {
        error.style.display = '';
        return;
      }
      fetch(url, {
        method: method,
        body: formData
      }).then(function (res) {
        if (res.ok) {
          return res.json();
        }
        throw new Error('There are some issues retrieving data.');
      }).then(function (json) {
        result.style.display = '';
        inner.innerHTML = json.data;
      })["catch"](function (e) {
        console.error(e);
      });
    });
    function handleReset() {
      error.style.display = 'none';
      result.style.display = 'none';
      inner.innerHTML = '';
    }
  };
  ns.handlePhProductFilterForm = function () {
    var form = document.querySelector('.product_list_filter_form');
    var letterGroups = form.querySelectorAll('.char_select__input_parent');
    var letters = form.querySelectorAll('.char_select__input_child');
    var efficacySelect = form.querySelector('#efficacy_input');
    var search = form.querySelector('.search_box__input');
    if (efficacySelect) {
      efficacySelect.addEventListener('change', handleEfficacyChange);
    }
    letterGroups.forEach(function (group) {
      group.addEventListener('change', handleLetterChange);
    });
    letters.forEach(function (letter) {
      letter.addEventListener('change', handleLetterChange);
    });
    form.addEventListener('submit', handleSearch);
    function handleEfficacyChange() {
      var efficacyMain = form.querySelector('input[name="efficacy_main"]');
      var efficacySub = form.querySelector('input[name="efficacy_sub"]');
      var efficacyMainValue = '';
      var efficacySubValue = '';
      if (efficacySelect.value) {
        var params = new URLSearchParams(efficacySelect.value);
        efficacyMainValue = params.get('efficacy_main');
        efficacySubValue = params.get('efficacy_sub');
      }
      efficacyMain.value = efficacyMainValue;
      efficacySub.value = efficacySubValue;
      form.submit();
    }
    function handleLetterChange() {
      search.value = '';
      handleSubmit();
    }
    function handleSubmit() {
      form.submit();
    }
    function handleSearch() {
      letterGroups.forEach(function (letter) {
        letter.checked = false;
      });
      letters.forEach(function (letter) {
        letter.checked = false;
      });
    }
  };
  ns.tableOfContent = function () {
    var right = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = document.querySelector('.section.--has_sticky_toc');
    var toc = document.getElementById('toc_container');
    if (!container || !toc) {
      return;
    }
    var trigger;
    var widthMedia = PUNITED.common.mediaQuery;
    init(widthMedia.matches);
    widthMedia.addEventListener('change', function (e) {
      init(e.matches);
    });
    function init(widthMatches) {
      destroy();
      handleScroll();
      if (!widthMatches) {
        create();
        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
      } else {
        gsap.set(toc, {
          display: 'flex',
          opacity: 1
        });
        window.removeEventListener('scroll', handleScroll);
      }
    }
    function create() {
      var headerOffset = 65;
      var topOffset = headerOffset + 32;
      var sectionOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--section-margin-y'), 10);
      trigger = ScrollTrigger.create({
        trigger: container,
        start: "top top+=".concat(topOffset, "px"),
        end: "bottom+=".concat(sectionOffset, "px bottom"),
        onEnter: function onEnter() {
          toc.classList.add('--sticky');
          gsap.to(toc, {
            display: 'flex',
            opacity: 1,
            duration: 0.3
          });
        },
        onEnterBack: function onEnterBack() {
          gsap.to(toc, {
            display: 'flex',
            opacity: 1,
            duration: 0.3
          });
        },
        onLeave: function onLeave() {
          gsap.to(toc, {
            display: 'none',
            opacity: 0,
            duration: 0.3
          });
        },
        onLeaveBack: function onLeaveBack() {
          toc.classList.remove('--sticky');
        }
      });
    }
    function destroy() {
      var _trigger;
      (_trigger = trigger) === null || _trigger === void 0 || _trigger.kill();
    }
    function handleScroll() {
      if (right) {
        var offset = document.documentElement.scrollWidth - document.documentElement.clientWidth - window.scrollX;
        toc.style.setProperty('--toc--offset--right', "".concat(-offset, "px"));
      } else {
        toc.style.setProperty('--toc--offset--left', "".concat(-window.scrollX, "px"));
      }
    }
  };
  ns.h2AccordionSwitch = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h2.--accordion_switch';
    var h2s = document.querySelectorAll(selector);
    var allAccordions = [];
    Array.from(h2s).reverse().forEach(function (h2, i) {
      var switchNode = document.createElement('div');
      switchNode.classList.add('heading_lv2__switch');
      var textOpenNode = document.createElement('span');
      textOpenNode.textContent = '全て開く';
      var textCloseNode = document.createElement('span');
      textCloseNode.textContent = '全て閉じる';
      switchNode.append(textOpenNode, textCloseNode);
      h2.append(switchNode);
      var subsequenceAccordions = Array.from(document.querySelectorAll("".concat(selector, ":nth-of-type(").concat(h2s.length - i, ") ~ .details_accordion")));
      var accordions;
      if (i === 0) {
        accordions = subsequenceAccordions;
      } else {
        var borderIndex = subsequenceAccordions.findIndex(function (accordion) {
          return accordion.isSameNode(allAccordions[i - 1][0]);
        });
        accordions = subsequenceAccordions.slice(0, borderIndex);
      }
      allAccordions.push(accordions);
      var initialOpen = accordions.length > 0 ? accordions.every(function (accordion) {
        return accordion.open;
      }) : false;
      switchNode.classList.toggle('--open', initialOpen);
      accordions.forEach(function (accordion) {
        var summary = accordion.querySelector('summary');
        summary.addEventListener('click', function () {
          if (accordion.dataset.animStatus === 'moving') {
            return;
          }
          if (accordion.open) {
            switchNode.classList.remove('--open');
          } else {
            var hasClose = accordions.some(function (a) {
              return !a.isSameNode(accordion) && !a.open;
            });
            switchNode.classList.toggle('--open', !hasClose);
          }
        });
      });
      switchNode.addEventListener('click', function (e) {
        var isAnimating = accordions.some(function (a) {
          return a.dataset.animStatus === 'moving';
        });
        if (isAnimating) {
          return;
        }
        var open = e.currentTarget.classList.toggle('--open');
        accordions.forEach(function (accordion) {
          if (open === accordion.open) {
            return;
          }
          var summary = accordion.querySelector('summary');
          summary.click();
        });
      });
    });
  };
  ns.h2Point = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h2';
    var h2s = document.querySelectorAll(selector);
    var tocItems = document.querySelectorAll('.toc_list > li');
    if (h2s.length !== tocItems.length) {
      return;
    }
    var count = 1;
    h2s.forEach(function (h2, i) {
      if (!h2.classList.contains('--point')) {
        return;
      }
      var number = "".concat(count).padStart(2, '0');
      var h2PointNode = document.createElement('span');
      h2PointNode.classList.add('heading_lv2__point');
      h2PointNode.textContent = number;
      h2.prepend(h2PointNode);
      var li = tocItems[i];
      var br = document.createElement('br');
      var tocPointNode = document.createElement('span');
      tocPointNode.classList.add('toc_item__point');
      tocPointNode.textContent = number;
      li.querySelector('a').prepend(tocPointNode, br);
      li.classList.add('--point');
      count += 1;
    });
  };
  ns.h3Feature = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h3';
    var h3s = document.querySelectorAll(selector);
    if (h3s.length < 1) {
      return;
    }
    h3s.forEach(function (h3) {
      if (!h3.classList.contains('--feature')) {
        return;
      }
      var h3FeatureNode = document.createElement('div');
      h3FeatureNode.classList.add('heading_lv3__feature');
      h3.prepend(h3FeatureNode);
    });
  };
  ns.autoCorpBtnIcon = function () {
    var icons = ['pdf'];
    var btns = document.querySelectorAll('.corp_block_editor_content .wp-block-button');
    btns.forEach(function (btn) {
      var a = btn.querySelector('.wp-block-button__link');
      var i = btn.querySelector('.btn__icon');
      var url = a.href;
      var blank = a.target === '_blank';
      var ext = url.split('.').at(-1);
      var icon = icons.includes(ext) ? ext : null;
      var iconWrapper = document.createElement('span');
      iconWrapper.classList.add('btn__icon');
      var iconContents = [];
      if (icon) {
        iconWrapper.classList.add("icon_".concat(icon));
      } else if (blank) {
        iconWrapper.classList.add('icon_external');
      } else {
        var iconContent = document.createElement('span');
        iconContent.classList.add('arrow');
        iconContents.push(iconContent, iconContent.cloneNode());
        btn.classList.add('--arrow');
      }
      iconWrapper.append.apply(iconWrapper, iconContents);
      if (i) {
        i.replaceWith(iconWrapper);
      } else {
        a.appendChild(iconWrapper);
      }
    });
  };

  /* -----------------------------------------------------
  	Call this in a page where slider or accordion is used.
  	Slider initialization screws up any scroll trigger instances that initialize before it.
  	So, force all scroll trigger instances to recalculate their positions after a slider is initialized.
  		If not done so, any animated elements that depend on scroll trigger below slider may not get triggered
  	and may not be visible.
  ----------------------------------------------------- */
  ns.refreshScrollTriggerPosition = function () {
    ScrollTrigger.refresh();
  };
  ns.addAjaxContentExternalLinksPopup = function (containerSelector, linkSelector) {
    var containers = document.querySelectorAll(containerSelector);
    if (containers.length < 1) {
      return;
    }
    containers.forEach(function (container) {
      var observer = new ResizeObserver(function () {
        var _PUNITED$common$exter;
        if (container.offsetHeight <= 0) {
          return;
        }
        (_PUNITED$common$exter = PUNITED.common.externalSiteLinkModalHandler) === null || _PUNITED$common$exter === void 0 || _PUNITED$common$exter.add(linkSelector);
        observer.disconnect();
      });
      observer.observe(container);
    });
  };
})();